module.exports = __webpack_public_path__ + "static/media/tire-mounting.699b8266.svg";